initLocationReview();
initBestGiftsElement();
if($("#discoverTheCollectionContent").is(":hidden")){
$("#discoverTheCollectionButtom").click();
}
$("#discoverTheCollectionContent").html("");
$("#discoverTheCollectionButtom").hide();
$(".shopify-section.section:nth-child(n+3)").css("max-width","960px").css("margin","0 auto");
var isMobile = window.innerWidth <= 750 ?1:0; 
if(!isMobile){
  $(".bannerTitleImg").css("width","70%");
  slideDivHtml();
  slideDivHtml1();
  init_you_may_also_like();
  initDiscoverCollectionHtml();
  initCompatibilityHtml();
  initSecure_spring_snap_clasp();
}else{
   slideDivHtml();
  init_you_may_also_like();
  $(".shopify-section.section:nth-child(n+3)").css("width","96%").css("margin","0 auto");
  $(".shopify-section.section:nth-child(2)>div.color-background-1>div>div").css("width","96%").css("margin","10px auto").css("display","block");
  $(".shopify-section.section:nth-child(2)>div.color-background-1>div>a.bannerImgAJL").css("width","96%").css("margin","10px auto").css("display","block");
  $("img.bannerTitleImg").css("width","96%").css("margin","10px auto").css("display","block");
  initCompatibilityHtml();
  initSecure_spring_snap_clasp();
  initAddToCartStyle();
  $("#freeShippingTable td").css("font-size","12px");
}


function slideDivHtml() {
  $(".slideDiv:eq(0)").css("display", "none");
  let top_best_gift_html = getTopBestGiftCollectionHtml();
  let {banner,swiper_html,link} = getBestGiftCollectionHtml();
  let width = 900;
  if(isMobile){
    width = document.querySelector("body").clientWidth;
    width = parseInt(width*1.2);
  }else{}
  banner = banner.replace(".jpg",`_${width}x.jpg`);
  let banner_html = `<a href="${link}"><img style="margin-bottom: 10px;" id="firstBannerImg" class="bannerImg lazyload" data-src="${banner}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606
"></a>`;
  $("#best_gift_collection").html(top_best_gift_html+banner_html+swiper_html);
  var swiper = new Swiper(".swiper-container", {
    pagination: ".swiper-pagination",
    slidesPerView: isMobile ? 2 : 4,
    paginationClickable: true,
    spaceBetween: 10,
  });
}

function getBestGiftCollectionHtml(){
  let collection_handle = getProductThemeName();  
  let best_gift_result = '';
  if(product_best_gifts_options.hasOwnProperty(collection_handle.toLocaleLowerCase())){
     best_gift_result = product_best_gifts_options[collection_handle.toLocaleLowerCase()];
  }else{}
  let swiper_html = `<div class="slideDiv">  <div class="swiper-container">
        <div class="swiper-wrapper">`;
  let banner = 'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/gona-2.jpg?v=1677205476';
  let link = '#';
  let slide = [
      'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/gift-1.jpg?v=1677205476',
      'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/gift-2.jpg?v=1677205476',
      'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/gift-3.jpg?v=1677205476',
      'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/gift-4.jpg?v=1677205476',
      'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/gift-5.jpg?v=1677205476',
      'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/gift-6.jpg?v=1677205476'
    ];
  if(best_gift_result){
    banner = best_gift_result['banner'];
    link = best_gift_result['link'];
    slide = best_gift_result['slide'];
  }
  $(".best-gift-banner-by-collection").data("src",banner);
  let width = isMobile?200:300;
  slide.forEach((image_url)=>{
      if(image_url.indexOf("|")!=-1){
          var arr = image_url.split('|');
          var slide_link = arr[0];
          image_url = arr[1];
      }else{
        var slide_link = "javascript:void(0);";
      }
      image_url = image_url.replace(".jpg",`_${width}x.jpg`);
      
      swiper_html += `<div class="swiper-slide"><a class="slideDivItem" href="${slide_link}">
        <img class="lazyload" data-src="${image_url}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606
">
    </a></div>`;
  });
  swiper_html += `</div>
        <!-- Add Pagination -->
        <div class="swiper-pagination" style="text-align:center;"></div>
    </div></div>`;
  return {banner:banner,swiper_html:swiper_html,link:link};
}

function getTopBestGiftCollectionHtml(){
  let width = 960;
  let title = 'THE BEST GIFTS FOR YOU';
  // let top_banner = 'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/1632e61ab381e075a76a586d9046fdc9.jpg?v=1689819886';
  // let top_link = 'https://gona.com/collections/barbiecore-blush';

  let top_banner = `https://cdn.shopify.com/s/files/1/0549/2051/1688/files/6e9e58f5e7dc2f29e0104777e38695c8.jpg?v=1708602133`;
  let top_link = 'https://gona.com/collections/enchante-lumiere';
  let collection_handle = getProductThemeName();  
  let top_best_gift_result = [];
  let mb_image = '';
  if(product_best_gifts_options.hasOwnProperty(collection_handle.toLocaleLowerCase())){
     top_best_gift_result = product_best_gifts_options[collection_handle.toLocaleLowerCase()];
     title = top_best_gift_result['title'];
     top_banner = top_best_gift_result['top_banner'];
     if(top_banner.indexOf('|')!=-1){
       let top_banner_arr = top_banner.split('|');
       top_banner = top_banner_arr[0];
       mb_image = top_banner_arr[1];
     }
     top_link = top_best_gift_result['top_link'];
  }
  if(isMobile){
    if(mb_image){
      top_banner = mb_image;
      width = 720;
    }else{
      width = document.querySelector("body").clientWidth * 1;
      width = parseInt(width);
    }
  }
  top_banner = getGiftSetTopBanner(top_banner);
  top_banner = top_banner.replace('.jpg',`_${width}x.jpg`);
  let top_best_gift_html = `
              <a id="best-gifts" style="width: 100%;height: auto;" href="${top_link}">
                <img class="lazyload" style="margin-bottom: 10px;" width="100%" data-src="${top_banner}"
                 src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606">
              </a>
              <div class="bannerTitleImg">
                <hr class="title_hr"/>
                <div class="title_txt">${title}</div>
              </div>`;
  return top_best_gift_html;
}

function slideDivHtml1(){
  $(".slideDiv:eq(1)").css("display","none");
  let swiper_html = `  <div class="swiper-container-pro">
        <div class="swiper-wrapper">`;
  document.querySelectorAll(".slideDiv .slideDivItem2").forEach((item)=>{
    let href = item.getAttribute("href");
    let img_src= item.querySelector("img").getAttribute("src");
    if(!img_src){
      img_src= item.querySelector("img").getAttribute("srcset");
    }
    
    swiper_html += `<div class="swiper-slide"><a href="${href}">
    <img loading="lazy"  class="img_lazy lazyload" data-src="${img_src}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606" style="width:100%;"/></a></div>`
  })
  swiper_html += ` </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination-pro" style="text-align:center;"></div>
    </div>`;
  $(".slideDiv:eq(1)").html(swiper_html).css("display","block");

  var swiper = new Swiper('.swiper-container-pro', {
        pagination: '.swiper-pagination-pro',
        slidesPerView: isMobile?2:4,
        paginationClickable: true,
        spaceBetween: 10
    });
}

function slideProductDivHtml(i){
  $(".section-template--19322627621209__f309c213-069b-4307-8986-7e43d8306438-padding .slideProductDiv:eq("+i+")").css("display","none");
  let swiper_product_html = `  <div class="swiper-container${i}">
        <div class="swiper-wrapper">`;
  document.querySelectorAll(".section-template--19322627621209__f309c213-069b-4307-8986-7e43d8306438-padding .slideProductDiv").forEach((items,index)=>{
      if(index != i)return;
    items.querySelectorAll(".slideProductDivItem").forEach((item)=>{
      let width = item.style.width;
    let product_href = item.getAttribute("href");
    let img_src= item.querySelector("img").getAttribute("src");
    if(!img_src){
      img_src= item.querySelector("img").getAttribute("srcset");
    }
    let product_title = item.closest("div").querySelector(".slideProductDivItemInfoTitle").innerText;
    let product_price = item.closest("div").querySelector(".slideProductDivItemInfoPrice").innerHTML;
    swiper_product_html += `<div class="swiper-slide">
    <a href="${product_href}"><img loading="lazy"  class="img_lazy lazyload" data-src="${img_src}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606" style="width:100%;border:1px solid #ccc;"/></a>
    <div clsss="slideProductDivItemInfoBox">
    <div class="slideProductDivItemInfoTitle">${product_title}</div>
    <div class="slideProductDivItemInfoPrice" style="text-align:center;">${product_price}</div>
    </div>
    </div>`;
  })
    
  swiper_product_html += ` </div>
        <!-- Add Pagination -->
            <div class="swiper-pagination${i}" style="text-align:center;"></div>
    </div>`;
  $(".section-template--19322627621209__f309c213-069b-4307-8986-7e43d8306438-padding .slideProductDiv:eq("+i+")").html(swiper_product_html).css("display","block");
  var swiper = new Swiper('.swiper-container'+i, {
        pagination: '.swiper-pagination'+i,
        slidesPerView: isMobile?2:4,
        paginationClickable: true,
        spaceBetween: isMobile?10:30
    });
    })
  if(isMobile){
  $(".slideProductDiv img").each(function(index,el){$(el).css("height",$(el).width()+"px");});
  }
}
function initDiscoverCollectionHtml(){
  $("#discoverTheCollectionContent .slideProductDiv").css("display","flex").css("justify-content",isMobile?"space-between":"left").css("flex-wrap","wrap");
  $("#discoverTheCollectionContent .slideProductDiv .productItemBox").css("width","auto");
  $("#discoverTheCollectionContent .slideProductDiv .productItemBox a").css("width","auto");
  $("#discoverTheCollectionContent .slideProductDiv .productItemBox .slideProductDivItemInfoBox").removeAttr("style");
  $("#discoverTheCollectionContent .slideProductDiv .productItemBox .slideProductDivItemInfoBox>div").removeAttr("style");
  $("#discoverTheCollectionContent .slideProductDiv .productItemBox").css("width",isMobile?"48%":"32%");
  if(isMobile){
    $("#discoverTheCollectionContent .slideProductDiv .productItemBox:nth-child(n+11)").css("display","none");
     $("#discoverTheCollectionContent .slideProductDiv .productItemBox").css("margin-right","0px");
  }
}

let product_collections_config = {
  "CyberDice":{
    "banner_title":"CYBERDICE COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner-3_2_e59ad973-4e0e-41ae-a403-0d61f224327e.jpg?v=1718361928",
    "key":"CyberDice",
    "link":"https://gona.com/collections/cyberdice-gona",
    "collection_name":"CyberDice",
  },
  "Enchanting Paris":{
    "banner_title":"ENCHANTING PARIS COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner-4_9d03f6e6-d583-4d5d-9ba3-ea3d0073ca28.jpg?v=1716547292",
    "key":"Enchanting Paris",
    "link":"https://gona.com/collections/enchanting-paris-gona",
    "collection_name":"Enchanting Paris",
  },
  "Easter Magic":{
    "banner_title":"EASTER MAGIC COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/20ea68957cae72fa3c60f43d71c4ada1.jpg?v=1709780585",
    "key":"Easter Magic",
    "link":"https://gona.com/collections/easter-magic",
    "collection_name":"Easter Magic",
  },
  "Springs Emerald Journey":{
    "banner_title":"SPRING`S EMERALD JOURNEY COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/6f89ec5790bc313745a520682f37486a.jpg?v=1709000221",
    "key":"Springs Emerald Journey",
    "link":"https://gona.com/collections/springs-emerald-journey-gona",
    "collection_name":"Springs Emerald Journey",
  },
   "Enchanted Light":{
    "banner_title":"ENCHANTÉLUMIÈRE COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/mh_A__5.jpg?v=1706078421",
    "key":"Enchanted Light",
    "link":"https://gona.com/collections/enchante-lumiere",
    "collection_name":"Enchanted Light",
  },
  "Emoji":{
    "banner_title":"EMOJI COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_5f26ae83-8061-40ef-b999-86bfcddad392.jpg?v=1723775073",
    "key":"Emoji",
    "link":"https://gona.com/collections/emoji-gona",
    "collection_name":"emoji-gona",
  },
  "Frozen":{
    "banner_title":"FROZEN COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/62f724dfaf1e8f7c79d07b6f74e68fb9_2a2731c1-119e-481a-972a-e86cadd0b974.jpg?v=1700819524",
    "key":"Frozen",
    "link":"https://gona.com/collections/frozen-gona",
    "collection_name":"frozen-gona",
  },
  "Dream Catcher Forever":{
    "banner_title":"DREAM CATCHER FOREVER",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/3fc810bf3c644181597d529824c51827.jpg?v=1735867931",
    "key":"Dream Catcher",
    "link":"https://gona.com/collections/dream-catcher-gona",
    "collection_name":"dream-catcher-gona",
  },
  "Wizard of Oz":{
    "banner_title":"WIZARD OF OZ COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_b93a1ea1-e819-45f8-aeb5-c3c258b70327.jpg?v=1682682477",
    "key":"Wizard of Oz",
    "link":"https://gona.com/collections/wizard-of-oz-gona",
    "collection_name":"wizard-of-oz-gona",
  },
  "ART DECO":{
    "banner_title":"ART DECO COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_7711f7c8-4072-4510-a0ef-cfd27b1ef842.jpg?v=1682682475",
    "key":"ART DECO",
    "link":"https://gona.com/collections/art-deco-gona",
    "collection_name":"art-deco-gona",
  },
  "Mom & Babies":{
    "banner_title":"MONACO VINTAGE COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_de73cd7c-c37e-4b24-85be-9d55b1650290.jpg?v=1682684574",
    "key":"Mom & Babies",
    "link":"https://gona.com/collections/monaco-red-gona",
    "collection_name":"monaco-red-gona",
  },
  "Constellation":{
    "banner_title":"THE STARRY COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_0663fdc4-073e-48b3-aa3a-e1f62dbcd409.jpg?v=1682682475",
    "key":"Constellation",
    "link":"https://gona.com/collections/starry-gona",
    "collection_name":"starry-gona",
  },
  "Starry":{
    "banner_title":"THE STARRY COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/85f9fff1137050555501b5a5726e8be5.jpg?v=1692602803",
    "key":"Starry",
    "link":"https://gona.com/collections/starry-gona",
    "collection_name":"starry-gona",
  },
  "Tree Of Life":{
    "banner_title":"TREE OF LIFE COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/0996086fd7b5fb028c00b3b87b5d4740.jpg?v=1683528431",
    "key":"Tree Of Life",
    "link":"https://gona.com/collections/tree-of-life-gona",
    "collection_name":"tree-of-life-gona",
  },
  "Versailles Palace":{
    "banner_title":"VERSAILLES PALACE COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/4fdb5a1fba9da4781d6f5328b9a80a92_663f23cb-ec5d-4523-86cc-546083abf9e2.jpg?v=1688528615",
    "key":"Versailles Palace",
    "link":"https://gona.com/collections/versailles-palace-gona",
    "collection_name":"versailles-palace-gona",
  },
  "Versailles Radiance":{
    "banner_title":"VERSAILLES PALACE COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/4fdb5a1fba9da4781d6f5328b9a80a92_663f23cb-ec5d-4523-86cc-546083abf9e2.jpg?v=1688528615",
    "key":"Versailles Radiance",
    "link":"https://gona.com/collections/versailles-palace-gona",
    "collection_name":"versailles-palace-gona",
  },
  "Marine":{
    "banner_title":"THE MARINE COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner-613-2_fde3d109-1a02-4c2f-9635-cb0d5182620f.jpg?v=1714466598",
    "key":"Marine",
    "link":"https://gona.com/collections/marine-gona",
    "collection_name":"marine-gona",
  },
  "Classic":{
    "banner_title":"THE CLASSIC COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_57a29069-8d64-4ccf-8fc0-fd5261be3d17.jpg?v=1682682474",
    "key":"Classic",
    "link":"https://gona.com/collections/classic-gona",
    "collection_name":"classic-gona",
  },
   "Love & Infinity":{
    "banner_title":"LOVE & INFINITY COLLECTION",
    "banner_img":"https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/06f60eafca1e5d32ace2e20ec7538bc6.jpg?v=1703753324",
    "key":"Love & Infinity",
    "link":"https://gona.com/collections/love-infinity-gona",
    "collection_name":"love-infinity-gona",
  },
  "Birthstone":{
    "banner_title":"BIRTHSTONE & CONSTELLATION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/cd6f7f477d25ad0a5a19891393a632f1.jpg?v=1695905232",
    "key":"Birthstone",
    "link":"https://gona.com/collections/birthstone-constellation-gona",
    "collection_name":"birthstone-constellation-gona",
  },
  "Halloween & Skull":{
    "banner_title":"HALLOWEEN & SKULL COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/c90e10691dc16867821f6831974d08f5_7b09d7ae-7ada-4d52-8081-171dd28ed2a7.jpg?v=1725952228",
    "key":"Halloween & Skull",
    "link":"https://gona.com/collections/halloween-skull-gona",
    "collection_name":"halloween-skull-gona",
  },
  "Initials":{
    "banner_title":"INITIALS COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_740b952d-641e-4760-8fd9-01471f4b2a6f.jpg?v=1682682475",
    "key":"Initials",
    "link":"https://gona.com/collections/initials-gona",
    "collection_name":"initials-gona",
  },
  "CloverGlow":{
    "banner_title":"CloverGlow Collection",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/a53a65b715eeb76271de89e1e750d5cc_fa833e7c-403d-4c43-8bda-fa20061fa509.jpg?v=1726817974",
    "key":"Clover",
    "link":"https://gona.com/collections/clover-gona",
    "collection_name":"clover-gona",
  },
  "Lucky Clover":{
    "banner_title":"CloverGlow Collection",
    "banner_img":"https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/a53a65b715eeb76271de89e1e750d5cc_5fe4c752-b646-42c5-be38-492a1f52d80e.jpg?v=1707209937",
    "key":"Lucky Clover",
    "link":"https://gona.com/collections/clover-gona",
    "collection_name":"clover-gona",
  },
  "Animals":{
    "banner_title":"HEARTFUL HUGS COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/900337b660ada25508ce36d5832065a4.jpg?v=1701933304",
    "key":"Animals & Pets",
    "link":"https://gona.com/collections/animals-gona",
    "collection_name":"animals-gona",
  },

  "Bracelets":{
    "banner_title":"BRACELET COLLECTION",
    //"banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/2bc19ff6e90c4dd1acb982f28b86db6b.jpg?v=1684113563",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/9d4ac60128df0cc9e047a4688507c387.jpg?v=1710992396",
    "key":"Bracelets",
    "link":"https://gona.com/collections/charm-bracelets-gona",
    "collection_name":"charm-bracelets-gona",
  },
  "Bracelet set":{
    "banner_title":"BRACELET SET COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/9d4ac60128df0cc9e047a4688507c387.jpg?v=1710992396",
    "key":"Bracelet set",
    "link":"https://gona.com/collections/1-bracelet-3charms-59-99-gona",
    "collection_name":"1-bracelet-3charms-59-99-gona",
  },
  "Earrings":{
    "banner_title":"EARRINGS COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/c58afacaf8e5579c7ec3d3648f90db2d.jpg?v=1684113563",
    "key":"Earrings",
    "link":"https://gona.com/collections/all-earrings-gona",
    "collection_name":"all-earrings-gona",
  },
  "Necklaces":{
    "banner_title":"NECKLACES COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/f94d5c245dc5e8dd04736da5b446c93d.jpg?v=1684113563",
    "key":"Necklaces",
    "link":"https://gona.com/collections/all-necklaces-gona",
    "collection_name":"all-necklaces-gona",
  },
  "WESTWORLD":{
    "banner_title":"WESTWORLD COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/16cb6409d53ac22f63e17bf32b98a523.jpg?v=1695363859",
    "key":"WESTWORLD",
    "link":"https://gona.com/collections/westworld-gona",
    "collection_name":"westworld-gona",
  },
  "Barbiecore Blush":{
    "banner_title":"BARBIECORE BLUSH COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/gona_-4_fa62fcd7-40ba-4c99-b920-513256dcae20.jpg?v=1716955198",
    "key":"Barbiecore Blush",
    "link":"https://gona.com/collections/barbiecore-blush",
    "collection_name":"barbiecore-blush",
  },
  "Noir Rose":{
    "banner_title":"NOIR ROSE COLLECTION",
    "banner_img":"https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/b21ff5f2294e508de02b25e3b3cab384.jpg?v=1693534217",
    "key":"Noir Rose",
    "link":"https://gona.com/collections/noir-rose-collection",
    "collection_name":"noir-rose-collection",
  },
  "Soulful Keys":{
    "banner_title":"SOULFUL KEYS COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/5ecd7df14b8acddd7556a78145d56cd4.jpg?v=1698027356",
    "key":"Soulful Keys",
    "link":"https://gona.com/collections/soulful-keys-gona",
    "collection_name":"soulful-keys-gona",
  },
  "Christmas":{
    "banner_title":"CHRISTMAS COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/a8b5b324d93caaf39bd280c24b081a59_0f06f2c6-a85c-4f48-a15a-58531d1bf2ed.jpg?v=1730949477",
    "key":"Christmas",
    "link":"https://gona.com/collections/christmas-gona-1",
    "collection_name":"christmas-gona-1",
  },
  "Venetian Dreamland":{
    "banner_title":"VENETIAN DREAMLAND",
    "banner_img":"https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/833abfae3136bbd0780e21c32e1f1d25.jpg?v=1700186123",
    "key":"Venetian Dreamland",
    "link":"https://gona.com/collections/venetian-dreamland",
    "collection_name":"venetian-dreamland",
  },
  "Glamour Fortune Whirl":{
    "banner_title":"GLAMOUR FORTUNE WHIRL",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/bd1b12db352322da9ee064c2e247fecd.jpg?v=1703230911",
    "key":"Glamour Fortune Whirl",
    "link":"https://gona.com/collections/glamour-fortune-whirl",
    "collection_name":"glamour-fortune-whirl",
  },
  "EmpowerMom":{
    "banner_title":"EMPOWERMOM COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/fbc202a8e892026c46a6445013a27410.jpg?v=1712113905",
    "key":"EmpowerMom",
    "link":"https://gona.com/collections/empowermom-gona",
    "collection_name":"empowermom-gona",
  },
  "Monaco Red":{
    "banner_title":"RÊVE DE MONACO COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/86358c5b7c5642c0c75529d94df909be.jpg?v=1712914250",
    "key":"Monaco Red",
    "link":"https://gona.com/collections/monaco-red-gona",
    "collection_name":"monaco-red-gona",
  },
  "Graduate Glories":{
    "banner_title":"GRADUATE GLORIES COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner-3_ee739885-7986-46b1-8629-d686de1b0fcb.jpg?v=1717664076",
    "key":"Graduate Glories",
    "link":"https://gona.com/collections/graduate-glories-gona",
    "collection_name":"graduate-glories-gona",
  },
  "An Invitation to Notre-Dame de Paris":{
    "banner_title":"NOTRE-DAME DE PARIS",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/987x1400.jpg?v=1717743278",
    "key":"An Invitation to Notre-Dame de Paris",
    "link":"https://gona.com/collections/notre-dame-de-paris-gona",
    "collection_name":"notre-dame-de-paris-gona",
  },
  "Sporting Spirit Charms":{
    "banner_title":"SPORTING SPIRIT CHARMS",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner-3_2_0d34315f-fd6b-40f6-af5c-ddd27fe58b4d.jpg?v=1721809458",
    "key":"Sporting Spirit Charms",
    "link":"https://gona.com/collections/sporting-spirit-charms-gona",
    "collection_name":"sporting-spirit-charms-gona",
  },
  "Blooming Waltz":{
    "banner_title":"BLOOMING WALTZ COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/a8b5b324d93caaf39bd280c24b081a59_2d94547a-73fa-4516-9ced-42eb3c2c4174.jpg?v=1733706257",
    "key":"Blooming Waltz",
    "link":"https://gona.com/collections/blooming-waltz-gona",
    "collection_name":"blooming-waltz",
  },
  "Lucky Streak":{
    "banner_title":"LUCKY STREAK COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/972400f3a53749e0cf83e516d690e246.jpg?v=1734331782",
    "key":"Lucky Streak",
    "link":"https://gona.com/collections/lucky-streak-gona",
    "collection_name":"lucky-streak-gona",
  },
  "Guardian Angel":{
    "banner_title":"GUARDIAN ANGEL COLLECTION",
    "banner_img":"https://cdn.shopify.com/s/files/1/0549/2051/1688/files/76c0a6b6dba7325f094f92619608df58.jpg?v=1736847659",
    "key":"Guardian Angel",
    "link":"https://gona.com/collections/guardian-angel",
    "collection_name":"guardian-angel",
  },
};

function getProductThemeName(){
  try{
    return JSON.parse($("#gonaProductInfoJson").val())['ProductThemes'];
  }catch(e){
    return '';
  }
}

initProductCollectionHtml();

function initProductCollectionHtmlV0(){
  try{
  let key = getProductThemeName();
  if(!product_collections_config[`${key}`]){
    key = productJson['type'];
    key = key.slice(0,1).toUpperCase() +key.slice(1).toLowerCase();
  }
  if(product_collections_config[`${key}`]){
    let config_data=product_collections_config[`${key}`];
    let link = config_data['link'];
    let banner_img = config_data['banner_img'];
    banner_img = getMediaImge(banner_img,1,960);
    
    let banner_title = config_data['banner_title'];
    let collection_name = config_data['collection_name'];
    let html = `
    <hr style="
    width: 55px;
    height: 5px;
    background: #090909;
    margin-top: 5px;
    margin-bottom: -5px;
    ">
    <div style="
        font-family: 'hc-2';
        font-size: 27px;
        color: #151515;
        margin-bottom:5px;
    ">${banner_title}</div>

    <a class="bannerImgAJL" href="${link}" style="width: 100%; margin: 0px auto; display: block;">
        <img class="bannerImg lazyload" loading="lazy" data-src="${banner_img}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606">
   </a>
    `;

    $("#product_collection_top").html(html);
    collection = collections.filter((item)=>{return collection_name == item['handle']});
    if(!collection)return;
    let products = getCollectionDataByName(collection_name);
    if(!products.length){
      // getCol(collection[0]['id']);
      // if(locationStorage.getItem(`get_col_${cid}`)){
      //   products = JSON.parse(locationStorage.getItem(`get_col_${cid}`));
      // }
      let products = getCollectionProductByCid(collection[0]['id']);
      return;
    }
     let discover_html = '';
    if(isMobile){
      discover_html = `<div id="discoverTheCollectionContent" style="display: block;">
  <div class="slideProductDiv">
  `;
      let inner_width = $("#discoverTheCollectionContent").width() /2   + 20;
      products.forEach((item)=>{
        var featured_image = getMediaImge(item['featured_image'],2);
         discover_html += `
      <div class="productItemBox">
  					<a class="slideProductDivItem" data-id="1" href="/products/${item['handle']}" style="width:${inner_width}px;height:${inner_width}px">
  						<img loading="lazy" class="lazyload" data-src="${featured_image}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606">
  					</a>
  					<div class="slideProductDivItemInfoBox" style="line-height: 12.42px; font-size: 12.42px;">
  						<div class="slideProductDivItemInfoTitle" style="width: 113.85px; height: 14.49px;">${item['title']}</div>
  						<div class="slideProductDivItemInfoPrice" style="height: 14.49px;"><span class="money">$${(item['price']/100).toFixed(2)}</span></div>
  					</div>
  				</div>
      `; 
      });
      discover_html += `<div></div>`
      $("#discoverTheCollectionContent").html(discover_html);
    }else{
      $("#discoverTheCollectionContent").css("display","none");
      discover_html = `  <div class="swiper-container-discover">
            <div class="swiper-wrapper">`;
      products.forEach((item)=>{
        var featured_image = getMediaImge(item['featured_image'],4);
        discover_html += `<div class="swiper-slide">
        <div class="productItemBox" style="display:block;">
  					<a class="slideProductDivItem" href="/products/${item['handle']}">
  						<img loading="lazy" class="lazyload" data-t="img" data-src="${featured_image}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606">
  					</a>
  					<div class="slideProductDivItemInfoBox" style="line-height: 12.42px; font-size: 12.42px;">
  						<div class="slideProductDivItemInfoTitle" style="width: 113.85px; height: 14.49px;">${item['title']}</div>
  						<div class="slideProductDivItemInfoPrice" style="height: 14.49px;"><span class="money">$${(item['price']/100).toFixed(2)}</span></div>
  					</div>
  				</div>
        </div>`;
      });
      discover_html += ` </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination-discover" style="text-align:center;"></div>
        </div>`;
      $("#discoverTheCollectionContent").html(discover_html).css("display","block");
    
      var swiper = new Swiper('.swiper-container-discover', {
            pagination: '.swiper-pagination-discover',
            slidesPerView: isMobile?2:4,
            paginationClickable: true,
            spaceBetween: 10
        });
    }
  }else{
    collection = collections.filter((item)=>{return item['title'].toLowerCase().indexOf(getProductThemeName().toLowerCase())!= -1});
    if(!collection)return;
    collection_name = collection[0]['handle']; 
    
    let products = getCollectionProductByCid(collection[0]['id']);
   }
  }catch(e){
  }
}
function initProductCollectionHtml(){
  try{
    let key = getProductThemeName();
    if(!product_collections_config[`${key}`]){
      key = productJson['type'];
      key = key.slice(0,1).toUpperCase() +key.slice(1).toLowerCase();
    }
    if(product_collections_config[`${key}`]){
      let config_data=product_collections_config[`${key}`];
      let link = config_data['link'];
      let banner_img = config_data['banner_img'];

      //指定款式替换上爱的抱抱系列banner
      let skus = get_animal_skus();
      let sku = productJson.variants[0]['sku'];
      if(skus.includes(sku)){
        banner_img = 'https://cdn.shopify.com/s/files/1/0549/2051/1688/files/banner_f90c4902-1b3b-45dd-8bd0-78861e020e68.jpg?v=1705885675';
      }
      banner_img = getMediaImge(banner_img,1,960);
      
      let banner_title = config_data['banner_title'];
      let collection_name = config_data['collection_name'];
      let html = `
      <hr style="
      width: 55px;
      height: 5px;
      background: #090909;
      margin-top: 5px;
      margin-bottom: -5px;
      ">
      <div style="
          font-family: 'hc-2';
          font-size: 27px;
          color: #151515;
          margin-bottom:5px;
      ">${banner_title}</div>
  
      <a class="bannerImgAJL" href="${link}" style="width: 100%; margin: 0px auto; display: block;">
          <img class="bannerImg lazyload" loading="lazy" data-src="${banner_img}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606">
     </a>
      `;
  
      $("#product_collection_top").html(html); 
    }
    collection = collections.filter((item)=>{return item['title'].toLowerCase().indexOf(getProductThemeName().toLowerCase())!= -1});
    if(!collection)return;
    collection_name = collection[0]['handle'];
    getCollectionProductByCid(collection[0]['id']);
  }catch(e){
  }
}

function get_animal_skus(){
  return [
'GCCC09608AD',
'GCCC09608GD',
'GCCC09738AD',
'GCCC09738GD',
'GCCC09739AD',
'GCCC09739GD',
'GCCC09740AD',
'GCCC09740GD',
'GCCC09741AD',
'GCCC09741GD',
'GCCC09742AD',
'GCCC09742GD',
'GCCC09743AD',
'GCCC09743GD',
'GCCC09744AM',
'GCCC09744GM',
'GCCC09745AM',
'GCCC09745GM',
'GCCC09746AM',
'GCCC09746GM',
'GCCC09945AD',
'GCCC09945GD',
'GCCC09972AD',
'GCCC09972GD',
'GCCC09971AD',
'GCCC09971GD',
'GCCC09970AD',
'GCCC09970GD'
]; 
}

function initCompatibilityHtml(){
  let tags = document.querySelector("#gonaProductTags")?document.querySelector("#gonaProductTags").value:'';
  if(getProductThemeName() == "Soulful Keys"){
     let html = `<img loading="lazy" class=" lazyloaded" data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/gona_-All_charms_569x.jpg?v=1684291336" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/791b6631610759e70d82c81bedc96a9e.jpg?v=1697794000" style="width: 100%;">`;
    $("#compatibility-content").html(html);
   }else if((getProductThemeName() == "WESTWORLD" || tags.indexOf("WESTWORLD")!= -1 || productJson['tags'].join(",").indexOf("WESTWORLD")!= -1) && productJson['type'].toLocaleLowerCase().indexOf("bracelet")!= -1){
    let html =`
     <p>Westworld bracelet is only suitable for Westworld collection products,do not
match the regular charms,do not match the regular clips,do not match the
regular safety chain.</p>
     <img class="lazyload" 
     data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/gona_7930973a-391f-48b8-855c-56ab8c9ba282_600x.jpg?v=1690797167" 
     src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606"
     style="width:100%"
     />`;
     $("#compatibility-content").html(html);
  }else if(productJson['type'] != "charms" && productJson['type'] != "safety chains"){
   let compatibility_html = `<div class="swiper-container-com">
            <div class="swiper-wrapper">`;
   let c_width = $(".compatibility").width();
    compatibility_html += `<div class="swiper-slide"><a href="https://gona.com/collections/all-charms-gona"><img loading="lazy" class="lazyload" data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/gona_-All_charms_${c_width}x.jpg?v=1684291336" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606"/></a></div>
        <div class="swiper-slide"><a href="https://gona.com/collections/clips-gona"><img loading="lazy" class="lazyload" data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/gona_-Clips_${c_width}x.jpg?v=1684291336" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606"/></a></div>
        <div class="swiper-slide"><a href="https://gona.com/collections/safety-chains-gona"><img loading="lazy" class="lazyload" data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/gona_-Comfort_chains_${c_width}x.jpg?v=1684291336" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606"/></a></div>`;
    compatibility_html += ` </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination-com" style="text-align:center;"></div>
        </div>`;
  $("#compatibility-content").html(compatibility_html);
  $("#compatibility-content .swiper-slide img").css("width","100%");
  
     var swiper = new Swiper('.swiper-container-com', {
            pagination: '.swiper-pagination-com',
            slidesPerView: 1,
            paginationClickable: true,
            spaceBetween: 10,
            observer: true, 
            observeParents: true,
        });
   }else{
     let html =`
     <p>GONA's charms are very inclusive,which can be applied to all bracelets,
necklaces and earrings of GONA,as well as bracelets and necklaces of
Pandora's equivalent brands.</p>
     <img class="lazyload" 
     data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/gona_-_q_94b839bf-03ae-40ce-97c4-b3bfa0cb65b4.jpg?v=1689736024" 
     src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606"
     style="width:100%"
     />`;
     $("#compatibility-content").html(html);
   }
}
function initLocationReview(){
    $("#gonaProductReviewsStart").click(function(){
       $("html,body").scrollTop($("#tab_pr_reivew").offset().top-50);
       if($("#jszd01-c02").css("display") == "none"){
        $("#tab_pr_reivew").click();
       }
  });
   if(location.href.indexOf("location_review=1")!=-1){
            var reviewIndex = setInterval(function(){
                if($("#looxReviewsFrame")){
                    document.querySelector("#tab_pr_reivew").click();
                    $("html,body").scrollTop($("#looxReviewsFrame").offset().top-200);
                    clearInterval(reviewIndex);
                    return;
                }              
            },1000);          
        }

}
initFixedAddCard();
function initFixedAddCard(){
  if(productJson['id'] == 7903769002226 || productJson['id'] == 8633990775129)return;
  let bootom_height = 0;
  let add_cart_html = `<div class="fixed_add_cart" style="
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0px;
    padding: 15px 0;
    z-index: 1 !important;
    display:none;
"><button style="
    display: block;
    width: 92%;
    padding: 15px 0;
    background: #B3BE93;
    color: #14141C;
    z-index:999;
    font-weight:800;
    border: 1px solid #3D3E38;
    border-radius: 50px;
    font-size: 13px;
    margin: 0 auto;
">ADD TO CART</button></div>`;


  
  if(isMobile){
    $("main#MainContent").after(add_cart_html);
    let is_disabled = 0;
    var cart_html_index = setInterval(function(){
      if($("#product-form-template--19322627621209__main button[type='submit']")){
        if($("#product-form-template--19322627621209__main button[type='submit']").prop("disabled")){
          is_disabled = 1;
        }
        if(is_disabled){
         $(".fixed_add_cart button").prop("disabled",true);
         $(".fixed_add_cart button").css("background","#7F7F7F");
          $(".fixed_add_cart button").css("color","#FFF");
         $(".fixed_add_cart button").text($("#product-form-template--19322627621209__main button[type='submit'] span").text().toLocaleUpperCase());
        }
        clearInterval(cart_html_index);
        return;
      }
    },1000);
   
    $(".fixed_add_cart").click(function(){
      // layer.msg('add to carting...');
      document.querySelector("#product-form-template--19322627621209__main button[type='submit']").click();
      //监控购物车内容显示
      setTimeout(function(){
        if($(".product-form__error-message-wrapper").css('display') != "none"){
         $("html,body").scrollTop($(".product-form__error-message-wrapper").offset().top-200);
        }
        },500);
    });

    let showTop = $("#product-policy-j > div:nth-child(1)").offset().top;
    $(window).scroll(function(event){
	  var toTop = $(window).scrollTop();
      if(toTop >= showTop){
        $(".fixed_add_cart").show();
      }else{
        $(".fixed_add_cart").hide();
      }
    });
  }
}

function initAddToCartStyle(){
  let style_str = `
  width: 100%;
    display: block;
    border-radius: 25px!important;
    display: block;
    padding: 15px 0;
    background: #B3BE93!important;
    color: #14141C;
    font-weight: 800!important;
    border: 1px solid #3D3E38;
    border-radius: 50px;
    `;
  $("#product-form-template--19322627621209__main .product-form__buttons button").attr("style",style_str);
  let btn_str = `font-size: 13px!important;
    font-weight: 800!important;
    font:-webkit-control;
    color: #14141C!important;`;
   $("#product-form-template--19322627621209__main .product-form__buttons button span").attr("style",btn_str);
}

function initSecure_spring_snap_clasp(){
  let img_url = 'https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/3_1.jpg?v=1684378526';
  if(productJson['type'].indexOf("bracelet") != -1 || productJson['type'].indexOf("bracelets")!=-1){
    let img_html = `<img loading="lazy" data-tt="i" srcset="${img_url}" style="width:100%;display:block;margin:0 auto;"/>`;
    // $("#shopify-section-template--19322627621209__f309c213-069b-4307-8986-7e43d8306438>div").after(img_html);
    $(".custom_recently_seen").after(img_html);
  }
}

function getMediaImge(source_img,column=1,max_width=0){
    var client_width = $("body").width()/column;
      client_width = parseInt(client_width);
    if(isMobile){
      var media_image = source_img.replace(".jpg",`_${client_width}x.jpg`);
    }else{
       if(max_width){
      client_width = parseInt(max_width);
    }
      var media_image = source_img.replace(".jpg",`_${client_width}x.jpg`);
    }
    return media_image;
}
console.log("product:"+productJson['id']);
//gift not single buy
if(productJson['id'] == 7903769002226 || productJson['id'] == 8633990775129){
  $(".product-form__submit").hide();
}
function initBestGiftsElement(){
  let themeName = getProductThemeName();

  let width = 960;
  if($("body").width() < 960){
    width = parseInt($("body").width());
  }
  if(themeName == 'Marine'){
    let imgHtml = `<img style="margin-bottom: 10px;" width="100%" data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/4b7227c51a8db2f84b7ce7c223d02906_${width}x.jpg?v=1688522209" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606" class="lazyload">`;
    $("a#best-gifts").html(imgHtml);
    $("#best-gifts").attr("href","https://gona.com/collections/marine-gona");
  }else{
    let imgHtml = `<img style="margin-bottom: 10px;" width="100%" data-src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/1632e61ab381e075a76a586d9046fdc9_${width}x.jpg?v=1689819886" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606" class="lazyload">`;
    $("a#best-gifts").html(imgHtml);
  }
}

function init_you_may_also_like(){
  let sku = meta.product.variants[0]['sku'];
  let collection = collections.filter((item) => {
      return  item["title"].toLocaleUpperCase().indexOf(getProductThemeName().toLocaleUpperCase())!=-1;
    });
  let collection_title = collection.length?collection[0]['title']:productJson['tags'].pop();
  collection_title = collection_title.replace("&","@");
  let color = '';
  var index = -1;
  productJson['options'].forEach((item,i)=>{if(["Finish","Stone Color","Enamel Color","Leather Color"].includes(item)){index = i;}});
  if(productJson['variants'][0]['options'][index]){
      color = productJson['variants'][0]['options'][index];
  }

  let url = `${main_api_url}/api/you-may-also-like?sku=${sku}&title=${collection_title}&color=${color}`;
  fetch(url).then((data)=>{return data.json()}).then((data)=>{
    let i = 0;
    let swiper_product_html = `<div class="swiper">  <div class="swiper-container swiper-container${i}">
        <div class="swiper-wrapper">`;
    data.data.forEach((item)=>{
        let handle = item['sku'].replace('.','-');
        let src = item['src'].replace(".jpg","_300x.jpg");
        src = src.replace(".webp","_300x.webp");
        swiper_product_html += `<div class="swiper-slide">
            <a href="/products/${handle}"><img class="lazyload " data-src="${src}" style="width:100%;border:1px solid #ccc;box-sizing:border-box;"/></a>
            <div clsss="slideProductDivItemInfoBox">
            <div class="slideProductDivItemInfoTitle">${item['title']}</div>
            <div class="slideProductDivItemInfoPrice" style="text-align:center;">$${item['price']}</div>
            </div>
            </div>`;
        });
        swiper_product_html += ` </div>
          <!-- Add Pagination -->
              <div class="swiper-pagination${i}" style="text-align:center;"></div>
      </div></div>`;
      $("#tem-new-gona").html(swiper_product_html);
      var swiper = new Swiper(".swiper-container" + i, {
        pagination: ".swiper-pagination" + i,
        slidesPerView: isMobile ? 2 : 4,
        paginationClickable: true,
        spaceBetween: isMobile ? 10 : 30
      });
  }).catch((error)=>{
    slideProductDivHtml(0);
  })
}

function getCollectionProductByCid(cid){
  return [];
  fetch(`${main_api_url}/api/get-collection-by-handle?cid=${cid}`).then(data=>{return data.json()}).then(data=>{
    web_img = data['data']['web_image'];
    if(web_img){
      web_img = web_img.replace('.jpg','_900x.jpg');
      $("#product_collection_top img").prop("srcset",web_img);
    }else{
      $("#product_collection_top").hide();
    }
    products = data['data']['products'].slice(0,10);
     let discover_html = '';
    if(isMobile){
      discover_html = `<div id="discoverTheCollectionContent" style="display: block;">
  <div class="slideProductDiv">
  `;
      let inner_width = $("#discoverTheCollectionContent").width() /2   + 20;
      products.forEach((item)=>{
        var featured_image = getMediaImge(item['src'],2);
         discover_html += `
      <div class="productItemBox">
  					<a class="slideProductDivItem" data-id="1" href="/products/${item['handle']}" style="width:${inner_width}px;height:${inner_width}px">
  						<img loading="lazy" class="lazyload" data-src="${featured_image}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606">
  					</a>
  					<div class="slideProductDivItemInfoBox" style="line-height: 12.42px; font-size: 12.42px;">
  						<div class="slideProductDivItemInfoTitle" style="width: 113.85px; height: 14.49px;">${item['title']}</div>
  						<div class="slideProductDivItemInfoPrice" style="height: 14.49px;"><span class="money">$${item['price']}</span></div>
  					</div>
  				</div>
      `; 
      });
      discover_html += `<div></div>`
      $("#discoverTheCollectionContent").html(discover_html);
    }else{
      $("#discoverTheCollectionContent").css("display","none");
      discover_html = `  <div class="swiper swiper-container-discover swiper-container5 swiper-container-horizontal">
            <div class="swiper-wrapper">`;
      products.forEach((item)=>{
        var featured_image = getMediaImge(item['src'],4);
        discover_html += `<div class="swiper-slide">
        <div class="productItemBox" style="display:block;">
  					<a class="slideProductDivItem" href="/products/${item['handle']}">
  						<img loading="lazy" class="lazyload" data-t="img" data-src="${featured_image}" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/loading_10x.jpg?v=1684892606">
  					</a>
  					<div class="slideProductDivItemInfoBox" style="line-height: 12.42px; font-size: 12.42px;">
  						<div class="slideProductDivItemInfoTitle" style="width: 113.85px; height: 14.49px;">${item['title']}</div>
  						<div class="slideProductDivItemInfoPrice" style="height: 14.49px;"><span class="money">$${item['price']}</span></div>
  					</div>
  				</div>
        </div>`;
      });
      discover_html += ` </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination-discover" style="text-align:center;"></div>
        </div>`;
      $("#discoverTheCollectionContent").html(discover_html).css("display","block");
    
      var swiper = new Swiper('.swiper-container-discover', {
            pagination: '.swiper-pagination-discover',
            slidesPerView: isMobile?2:4,
            paginationClickable: true,
            spaceBetween: 10
        });
    }
  });
}

async function getCol(cid){
  let res = await fetch(`https://apihk.gona.com/api/get-collection-by-handle?cid=${cid}`);
  let {data} = await res.json();
  return data['products'];
}

function getCollectionDataByName(collection_name){
   
}

function getGiftSetTopBanner(top_banner){
  try{
    //如果是礼品装GTDC10001GD,GTDC10000GM,GTDC09999GM,GTDC09998GM
    let gift_set_skus = ["GTDC10001GD","GTDC10000GM","GTDC09999GM","GTDC09998GM"];
    let sku = productJson.variants[0]['sku'];
    let is_gift_set_sku = 0;
    gift_set_skus.forEach((item)=>{
      if(sku.indexOf(item) != -1){
        is_gift_set_sku = 1;
      }
    });
    if(is_gift_set_sku == 1){
      top_banner = "https://cdn.shopify.com/s/files/1/0549/2051/1688/files/94de6bf612c656bc439599e7b8b16822.jpg?v=1699843107";
    }
  }catch(e){}
  return top_banner;
}

